import { DatePipe, DatePipeConfig } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { IUserHistory, UserHistoryService } from '@soleran/audit';
import { MAX_PAGE_SIZE } from '@soleran/report';
import { Locale } from 'moment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-advanced-search-history-table',
  templateUrl: './advanced-search-history-table.component.html',
  styleUrls: ['../search-table.scss'],
})
export class AdvancedSearchHistoryTableComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() title = 'History';
  @Input() term!: string;
  @Input() pageSize = 8;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @Output() itemClick = new EventEmitter<IUserHistory>();
  readonly dateFormat = 'M/dd/yyyy';
  readonly columnDefs = ['name', 'module', 'updatedDate'];
  dataSource!: MatTableDataSource<IUserHistory | any>;
  private _subs = new Subscription();

  constructor(private _hist: UserHistoryService) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<IUserHistory>([]);

    this.dataSource.filterPredicate = (row: IUserHistory, value: string) => {
      return Object.keys(row)
        .map((key) => (row as any)[key] as string)
        .filter((v) => !!v)
        .join('◬')
        .toLocaleLowerCase()
        .includes(value);
    };
    this.dataSource.paginator = this.paginator;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['term']) {
      this._subs.add(
        this._getHistory().subscribe((histories) => {
          this.dataSource.data = histories;
          this.dataSource.filter = this.term?.toLocaleLowerCase();
        })
      );

      if (this.dataSource) {
        this.dataSource.filter = this.term?.toLocaleLowerCase();
      }
    }
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

  private _getHistory() {
    return this._hist.get({ searchText: this.term, pageSize: MAX_PAGE_SIZE });
  }
}
